import { useTranslation } from "react-i18next";
import { Label, Input, Textarea } from "@tellescope/ui";
import type { CardBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import type { BlockTypeEditorProps } from "../types";

type CardBlockEditorProps = BlockTypeEditorProps<CardBlock>;

export function CardBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: CardBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Title")}</Label>
        <Input
          value={block.props.title || ""}
          onChange={(e) => updateProps({ title: e.target.value || undefined })}
          placeholder={t("Card title...")}
        />
      </div>
      <div className="space-y-2">
        <Label>{t("Description")}</Label>
        <Textarea
          value={block.props.description || ""}
          onChange={(e) => updateProps({ description: e.target.value || undefined })}
          placeholder={t("Card description...")}
          rows={3}
        />
      </div>
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
